<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>
    <div class="flex flex-col gap-1 max-w-[500px]">
      <span class="text-xl font-semibold">
        {{ "MasterData.PlansGrid.NotifyHeadsOfCountryTitle" | i18nextEager: { year: year() } }}
      </span>
      <span class="text-text-ultra-light font-light">
        {{ "MasterData.PlansGrid.NotifyHeadsOfCountrySubtitle" | i18nextEager }}
      </span>
    </div>
  </ng-template>
  <ng-template #content>
    @if (isLoading()) {
      <div class="flex justify-center items-center py-10">
        <app-spinner />
      </div>
    } @else {
      <app-country-checkbox-list
        [options]="countryOptions()"
        [(selectedIds)]="selectedCountryIds"
        testIdPrefix="notify-heads-of-country"
      />
    }
  </ng-template>

  <ng-template #footer>
    <div class="flex w-full gap-md pt-4 items-center justify-end">
      <doka-button
        (click)="closeModal()"
        color="secondary"
        [disabled]="isLoading()"
        data-testid="notify-heads-of-country-cancel-button"
      >
        {{ "Common.Cancel" | i18nextEager }}
      </doka-button>
      <doka-button
        (click)="submit()"
        color="primary"
        icon="send"
        data-testid="notify-heads-of-country-send-button"
        [disabled]="isLoading() || selectedCountryIds().size === 0"
        [buttonText]="'MasterData.PlansGrid.SendNotification' | i18nextEager"
      />
    </div>
  </ng-template>
</doka-modal-wrapper>
